import * as React from "react";
const SvgFiRrJugAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-jug-alt_svg__a)">
      <path
        fill="#062147"
        d="M19 4c-1.129 0-2.204.442-2.947 1.213a3.75 3.75 0 0 0-.827 1.347l-.503-.587A3 3 0 0 1 14 4.02V1.999a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2V4.02a3 3 0 0 1-.722 1.952l-4.074 4.753A5 5 0 0 0 1 13.978v5.021c0 2.757 2.243 5 5 5h9c2.757 0 5-2.243 5-5l-.011-5.139C21.715 13.417 23 11.861 23 9.999v-2A4.003 4.003 0 0 0 19 4M3 15h10.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H3zm15 4c0 1.654-1.346 3-3 3H6a3 3 0 0 1-2.816-2H13.5c1.379 0 2.5-1.122 2.5-2.5v-2c0-1.378-1.121-2.5-2.5-2.5H3.17c.122-.353.306-.685.552-.973l4.074-4.753A5 5 0 0 0 9 4.021V2h3v2.021c0 1.192.427 2.348 1.204 3.254l4.073 4.752c.466.544.723 1.237.723 1.953zm3-9c0 .917-.623 1.683-1.466 1.918a5 5 0 0 0-.738-1.193L17 8.629v-.665c-.019-.538.151-1.009.493-1.362.368-.383.918-.602 1.508-.602 1.103 0 2 .897 2 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-jug-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrJugAlt;
